import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import Sidebar from "../../components/sidebar/sidebar";
import IndividualCount from "../../components/dashboardComponent/IndividualCount";
import CollectionCount from "../../components/dashboardComponent/collectionCount";
import { getDashboardService } from "../../services/dashboardService"; // Adjust the import path as needed
import useStore from "../../useStore";

function Dashboard() {
  
  // Initialize dates to today's date
  const today = new Date().toISOString().split("T")[0];
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [loading, setLoading] = useState(false);
  const { setDashboardDetails } = useStore();

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await getDashboardService(startDate, endDate);
      setDashboardDetails(response);
      console.log(response);
      // Simulate a delay of 2 seconds
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    // Call the service once when the component mounts
    fetchData();
  }, []);

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };

  const handleGenerateClick = async () => {
    await fetchData();
  };

  return (
    <>
      <div
        style={{
          backgroundColor: "#eee",
        }}
      >
        <Box sx={{ display: "flex" }}>
          <Sidebar />
          <Box component="main" sx={{ flexGrow: 1, pt: 3, pr: 2 }}>
            <Box height={80} />

            {loading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100vh",
                }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <>
                <Grid container>
                  <Grid item xs={7}>
                    <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                      Welcome,{" "}
                      {/* <span style={{ textTransform: "capitalize", color: "purple" }}>
                      <em> {profileData?.name}</em>
                    </span>{" "} */}
                      🙏
                    </Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        m: 1,
                      }}
                    >
                      <TextField
                        type="date"
                        size="small"
                        value={startDate}
                        onChange={handleStartDateChange}
                        sx={{ background: "#fff", borderRadius: "8px" }}
                      />
                      <TextField
                        type="date"
                        size="small"
                        value={endDate}
                        onChange={handleEndDateChange}
                        sx={{ background: "#fff", borderRadius: "8px" }}
                      />
                      <Button
                        variant="contained"
                        size="small"
                        onClick={handleGenerateClick}
                        sx={{
                          py: 0.5,
                          textTransform: "capitalize",
                          fontSize: "16px",
                          borderRadius: "8px",
                        }}
                      >
                        Generate
                      </Button>
                    </Box>
                  </Grid>
                </Grid>

                <Box mt={2} />
                <IndividualCount />
                <CollectionCount />
              </>
            )}
          </Box>
        </Box>
      </div>
    </>
  );
}

export default Dashboard;
